module.exports = __webpack_public_path__ + "static/media/crypto-logoW.e1cf2689.png";